import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorHandlerService } from '../../../services/http-error-handler.service';
import { NotificationsService } from '../../../services/notifications.service';
import { NotificationTypeDto } from '../../../shared-new/enums/notification-type.enum';
import { ToastService } from '../../../shared-new/services/toast.service';

@Component({
  selector: 'app-notification-type-edit',
  templateUrl: './notification-type-edit.component.html',
  styleUrls: ['./notification-type-edit.component.scss']
})
export class NotificationTypeEditComponent implements OnInit {

  constructor(private readonly notificationService: NotificationsService, private activatedRoute: ActivatedRoute, private router: Router, private toastService: ToastService, private httpError: HttpErrorHandlerService) { }
  public notificationType: NotificationTypeDto | null = null;
  public get notificationTypeId(): number {
    return this.activatedRoute.snapshot.params['id'];
  }

  ngOnInit(): void {
    this.notificationService.getNotificationTypeById(this.notificationTypeId).subscribe({
      next: (data) => {
        this.notificationType = data;
      },
      error: (err) => this.httpError.ShowErrorMessage(err)
    });
  }

  saveNotificationType() {

    this.notificationService.updateNotificationType(this.notificationType).subscribe({
      next: (data) => {
        this.toastService.success('Notification Type updated successfully');
        this.goToList();
      },
      error: (err) => this.httpError.ShowErrorMessage(err)
    });
  }
  goToList(): void {
    this.router.navigateByUrl('/notification-type');
  }
}
